import Section from '../Section';

export default class LogoList extends Section {

}
